import React, { useState } from 'react'

const useCaptureDataAndGeneratePDFBrowserAPI = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleWideTables = (clone) => {
    const tableWrappers = clone.querySelectorAll('.table-view');

    tableWrappers.forEach((wrapperDiv) => {
      const table = wrapperDiv.querySelector('table.templates-table');
      if (!table) return;

      const printableWidthPx = 1000;
      if (table.scrollWidth <= printableWidthPx) return;

      const firstRow = table.rows[0];
      if (!firstRow) return;
      const totalCols = firstRow.cells.length;

      // 1. Measure the ACTUAL rendered width of each column
      const colWidths = Array.from(firstRow.cells).map(cell => cell.getBoundingClientRect().width);

      // 2. Dynamically group columns into chunks based on actual physical width
      const groups = [];
      let currentGroup = [];
      let currentWidth = 0;

      for (let i = 0; i < totalCols; i++) {
        const cellWidth = colWidths[i];

        if (currentWidth + cellWidth > printableWidthPx && currentGroup.length > 0) {
          groups.push(currentGroup);
          currentGroup = [i];
          currentWidth = cellWidth;
        } else {
          currentGroup.push(i);
          currentWidth += cellWidth;
        }
      }
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      if (groups.length <= 1) return;

      const container = document.createElement('div');
      container.className = 'chunked-table-container';

      groups.forEach((colIndexes) => {
        const tableClone = table.cloneNode(true);

        Array.from(tableClone.rows).forEach((row) => {
          Array.from(row.cells).forEach((cell, idx) => {
            if (!colIndexes.includes(idx)) {
              cell.style.display = 'none';
            } else {
              const cellText = cell.textContent.trim();
              if (cellText === '' || cellText === '.' || cellText === '-') {
                cell.innerHTML = '&nbsp;';
              }
            }
          });
        });

        const chunkWrapper = document.createElement('div');
        chunkWrapper.className = 'chunk-wrapper';
        chunkWrapper.style.pageBreakInside = 'avoid';
        chunkWrapper.appendChild(tableClone);

        container.appendChild(chunkWrapper);
      });

      const innerDiv = table.parentElement;
      innerDiv.replaceWith(container);
    });
  };


  const captureDataAndGeneratePDF = async (componentRef, fileName) => {

    console.log(componentRef, fileName);

    if (!componentRef?.current) return;
    setIsLoading(true);

    const element = componentRef.current;
    const sections = element.querySelectorAll('.ar_native_pdf_design, .print_pdf');

    const printContainer = document.createElement('div');
    printContainer.id = 'print-container';
    document.body.appendChild(printContainer);

    sections.forEach((section, index) => {
      const clone = section.cloneNode(true);
      const wrapper = document.createElement('div');
      wrapper.appendChild(clone);
      wrapper.style.pageBreakBefore = index === 0 ? 'auto' : 'always';
      wrapper.style.pageBreakInside = 'avoid';

      printContainer.appendChild(wrapper);

      handleWideTables(clone);

      clone.querySelectorAll('*').forEach((child) => {
        // ⭐ FIX: If this element belongs to the chunked table containers, 
        // skip forcing overflow: visible so it won't display a scrollbar.
        if (child.closest('.chunked-table-container')) return;

        const style = window.getComputedStyle(child);
        const constrained =
          ['auto', 'scroll', 'hidden'].includes(style.overflowX) ||
          ['auto', 'scroll', 'hidden'].includes(style.overflowY) ||
          style.whiteSpace === 'nowrap' ||
          style.textOverflow === 'ellipsis';

        if (constrained) {
          child.style.overflow = 'visible';
          child.style.overflowX = 'visible';
          child.style.overflowY = 'visible';
          child.style.textOverflow = 'clip';
          child.style.whiteSpace = 'normal';
          child.style.wordBreak = 'break-word';
          child.style.height = 'auto';
          child.style.maxHeight = 'none';
        }
        child.style.webkitFontSmoothing = 'antialiased';
      });
    });

    const style = document.createElement('style');
    style.innerHTML = `
      @media screen {
        #print-container { display: none !important; }
      }
      @media print {
        .sidebar { display: none !important; }
        body > * { display: none !important; }
        #print-container {
          display: block !important;
          position: static !important;
          width: 100% !important;
          padding: 10px 5px !important;
          margin: 0 !important;
        }
        .page-section {
          page-break-before: always;
          padding-top: 20px;
        }
        * {
          font-family: var(--font-m), 'Poppins', sans-serif !important;
        }
        #print-container > * {
          page-break-inside: avoid !important;
        }
        .ar_patient_detail_message {
          page-break-after: always !important;
        }
        .ar_page_break:not(:has(+.ar_print_footer)) {
          page-break-after: always !important;
        }
        .ar_print_footer {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          z-index: 1000;
        }
        .cover-latter-header {
          display: flex !important;
        }
        .chunk-wrapper table {
          table-layout: fixed !important;
          width: 100% !important;
          margin: 0 !important;
          border-collapse: collapse !important;
        }
        .chunk-wrapper td, .chunk-wrapper th {
            word-break: normal;         
            min-width: auto;            
            white-space: normal !important;   
            vertical-align: top !important
        }
        .chunk-wrapper {
          margin: 0 !important;
          padding: 0 !important;
          margin-bottom: 4px !important;
        }
      }
    `;
    document.head.appendChild(style);

    await document.fonts.ready;

    const originalTitle = document.title;
    if (fileName) document.title = fileName;

    const cleanup = () => {
      document.title = originalTitle;
      printContainer.remove();
      style.remove();
      setIsLoading(false);
    };

    window.addEventListener('afterprint', cleanup, { once: true });

    setTimeout(() => {
      window.print();
    }, 100);
  };

  return { isLoading, captureDataAndGeneratePDF };
};

export default useCaptureDataAndGeneratePDFBrowserAPI;